export default {"src":"/_next/static/media/Notification.93657a8e.svg","height":31,"width":25,"blurWidth":0,"blurHeight":0};